import { Page } from '../../../../../components/page/page';
import s from './employee-profile.module.css';
import { useEmployeeProfile } from './use-employee-profile';
import { Loader } from '../../../../../components/loader/loader';
import { EmployeeProfileDownload } from './employee-profile-download/employee-profile-download';
import { EmployeeProfileSettings } from './employee-profile-settings/employee-profile-settings';

export const EmployeeProfile = () => {
  const {
    employee,
    updatedEmployee,
    handleUpdateEmployee,
    t,
    employeeId,
    handleSave,
    isLoading,
    handleUploadImage,
    qr,
    setQr,
    isChanged,
    employeeUrl,
  } = useEmployeeProfile();

  return (
    <Page className={s.page}>
      {isLoading && <Loader />}
      {!!employee && !!updatedEmployee ? (
        <>
          <EmployeeProfileSettings
            employee={updatedEmployee}
            handleUpdateEmployee={handleUpdateEmployee}
            handleSave={handleSave}
            handleUploadImage={handleUploadImage}
            isChanged={isChanged}
          />
          <EmployeeProfileDownload
            employee={employee}
            qr={qr}
            setQr={setQr}
            employeeUrl={employeeUrl}
          />
        </>
      ) : (
        <div className={s.empty} style={{ display: isLoading ? 'none' : 'block' }}>
          <h3>{t('Профиль не найден')}</h3>
          <p>{t('Пожалуйста, проверьте правильность введенного ID сотрудника.')}</p>
          <p>
            {t('ID сотрудника:')} {employeeId}
          </p>
        </div>
      )}
    </Page>
  );
};
